import { SET_GROUPS_OF_USER } from "../actions/groupsOfUserActions";

const defaultState = {
  groupsOfUser: [],
  current: null,
  isMasterUser: false,
};

export const SET_USER = "SET_USER";
export const LOG_OUT = "LOG_OUT";

export const userReducer = (state = defaultState, action: any) => {
  const { type, data } = action;
  const masterUserList = [
    "botit@viags.vn",
    "canbo1@viags.vn",
    "anhnk@viags.vn",
    "chinhy@viags.vn",
    "andt@viags.vn",
    "ngannth@viags.vn",
    "huyenpn@viags.vn",
    "vanntq@viags.vn",
  ];
  if (type === SET_USER)
    return { ...(state || {}), current: data, isMasterUser: masterUserList.includes(data?.username?.toLowerCase()) };
  if (type === SET_GROUPS_OF_USER) return { ...(state || {}), groupsOfUser: data };
  if (type === LOG_OUT) return defaultState;
  return state;
};
